import { Injectable } from '@angular/core';
import { SxHttpService } from './sxHttp.service';
import { Observable } from 'rxjs/Observable';
import { environment } from 'environments/environment';
import { Rule, TryCompileResponse, TryCompileRequest, RuleComponent } from '../model/interfaces/rule.interface';
import { RuleCompilationResult } from '../model/classes/rule.class';

/**
 * Representa un SxSoc_Regla en el backend
 */

@Injectable()
export class RuleService {
  private url = 'api/configuracionRegla';

  readonly sourceCodeText = 'Source Code:';

  constructor(private sxHttp: SxHttpService) { }

  /**
   * Obtiene una regla desde el backend
   */
  getRegla(codRegla): Promise<Rule> {
    const url = `${this.url}/${codRegla}`;

    return this.sxHttp.get(url)
      .toPromise()
      .then(response => response.json().data as Rule)
      .catch(this.handleError);
  }

  tryCompile(tryCompileData: TryCompileRequest): Observable<TryCompileResponse> {
    const url = `${this.url}/CheckSyntax`;

    return this.sxHttp.post(url, tryCompileData)
      .map(response => response.json().data)
      .map(data => {
        let res = new RuleCompilationResult();

        if (!data.compileResult.isOk) {
          res.compilationErrors = this.processErrors(data.compileResult.erroresConcatenados);
        }

        data.compileResult = res;
        return data;
      });
  }

  private processErrors(concatenatedErrors: string): string {
    let res = '';

    const errorLines = concatenatedErrors.split('\n');
    const sourceCodeIndex = errorLines.findIndex(line => line.startsWith(this.sourceCodeText));

    if (sourceCodeIndex != -1) {
      const splitIndex = sourceCodeIndex + 1;
      const errorReportLines = errorLines.slice(0, splitIndex);
      errorReportLines.forEach(errorLine => res += `${errorLine}\n`);

      const sourceLines = errorLines.slice(splitIndex);
      sourceLines.forEach((sourceLine, index) => res += `${index + 1}: ${sourceLine}\n`);
    } else {
      errorLines.forEach(errorLine => res += `${errorLine}\n`);
    }

    return res;
  }

  getReglaAsObservable(codRegla): Observable<Rule> {
    const url = `${this.url}/${codRegla}`;

    return this.sxHttp.get(url)
      .map(response => response.json().data as Rule);
  }

  /**
   * Crea una nueva regla en el backend
   */
  crear(regla: Rule): Promise<Rule> {
    return this.sxHttp.post(this.url, regla)
      .toPromise()
      .then(response => response.json().data as Rule)
      .catch(this.handleError);
  }

  /**
   * Actualiza una regla en el backend
   */
  editar(regla: Rule): Promise<Rule> {
    const url = `${this.url}/${regla.idRegla}`;

    return this.sxHttp.put(url, regla)
      .toPromise()
      .then(response => response.json().data as Rule)
      .catch(this.handleError);
  }

  cambiarAVersion(reglaId: string, historialId: number): Promise<Rule> {
    const url = `${this.url}/${reglaId}/${historialId}`;

    return this.sxHttp.put(url, {})
      .toPromise()
      .then(response => response.json().data as Rule)
      .catch(this.handleError);
  }

  getComponentes(codEvento: string, codServicio: string): Promise<RuleComponent[]> {
    const url = `${this.url}/componentes/${codEvento}/${codServicio}`;

    return this.sxHttp
      .get(url)
      .toPromise()
      .then(response => response.json().data as RuleComponent[]);
  }

  // for directDelete of a rule
  delete(id: string): Promise<any> {
    const url = `${this.url}/Delete`;

    return this.sxHttp.post(url, { idRegla: id })
      .toPromise()
      .then(response => response.json().data as Boolean)
      .catch(this.handleError);
  }

  invalidateCache(codRegla : string, codSistema: string,
    codNegocio: string,codProducto: string) : Promise<any>{
      const url = `${this.url}/InvalidateCache`
    
      return this.sxHttp.post(url, {idRegla: codRegla, SystemCode: codSistema,
        BusinessCode: codNegocio})
                        .toPromise()
                        .then(response => response.json().data as Boolean)
                        .catch(this.handleError);
  }

  private handleError(error: any): Promise<any> {
    console.error('Ocurrió un error', error);
    return Promise.reject(error.message || error);
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/infrastructure/services/reglas.service.ts